import { GetTransactionsByPageBodyTx_type } from "@gen/app-query";
import * as z from "zod";

export const adminTransactionsReqSchema = z.object({
  page: z.coerce.number().min(1).default(1),
  pageSize: z.coerce.number().min(1).max(100).default(25),
  tx_type: z
    .enum(GetTransactionsByPageBodyTx_type)
    .default(GetTransactionsByPageBodyTx_type.F2f),
  tx_id: z.coerce.string().optional(),
  total_price_from: z.string().optional(),
  total_price_to: z.string().optional(),
  descr: z.string().optional(),
  email: z.string().optional(),
  date_created_from: z.string().optional(),
  date_created_to: z.string().optional(),
  currency: z.string().optional(),
  client_site: z.string().optional(),
  exclude_status: z.string().optional(),
  f2f_txs_status: z.array(z.string()).optional(),
  online_txs_status: z.array(z.string()).optional(),
});
